import { useState, useCallback } from 'react';
import { getBranchAdvisers } from '../api/contract_templates';

export const useAdvisers = () => {
  const [advisers, setAdvisers] = useState([]);
  const [selectedAdviser, setSelectedAdviser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAdvisers = useCallback(async (onAdviserSelected) => {
    setLoading(true);
    setError(null);
    try {
      const advisersData = await getBranchAdvisers();
      setAdvisers(advisersData);
      
      // Default to current user if they're in the list
      const currentUser = advisersData.find(adviser => adviser.is_current_user);
      let defaultAdviserId = null;
      
      if (currentUser) {
        defaultAdviserId = currentUser.id;
      } else if (advisersData.length > 0) {
        // If current user not found, default to first adviser
        defaultAdviserId = advisersData[0].id;
      }
      
      if (defaultAdviserId) {
        setSelectedAdviser(defaultAdviserId);
        // Call the callback to fetch adviser details for the default selection
        if (onAdviserSelected) {
          onAdviserSelected(defaultAdviserId);
        }
      }
    } catch (error) {
      console.error('Error fetching advisers:', error);
      setError('Failed to load advisers');
      setAdvisers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const resetAdvisers = useCallback(() => {
    setAdvisers([]);
    setSelectedAdviser(null);
    setLoading(false);
    setError(null);
  }, []);

  return {
    advisers,
    selectedAdviser,
    advisersLoading: loading,
    advisersError: error,
    setSelectedAdviser,
    fetchAdvisers,
    resetAdvisers,
  };
}; 